<template>
  <v-container class="cmp-booking-venue-sidewindow dt-sidewindow">
    <div class="dt-tabs-container">
      <VenueDetails :venue="selectedVenue.location"></VenueDetails>
      <glayout
        :tabs="venuSidewindowTabs"
        :loading="selectedVenue && selectedVenue.loading"
      >
        <gtab>
          <grow>
            <gcol>
              <gbox :title="$t('location_info')">
                <VenueInfo :venue="selectedVenue" @changed="onVenueChange" />
              </gbox>
            </gcol>
            <gcol>
              <gbox :title="$t('communication_info')">
                <Communication
                  :venue="selectedVenue"
                  @changed="onVenueChange"
                />
              </gbox>
              <gbox :title="$t('location_info')">
                <VenueInfo2 :venue="selectedVenue" @changed="onVenueChange" />
              </gbox>
            </gcol>
          </grow>
        </gtab>
        <gtab id="additional_info">
          <grow>
            <gcol>
              <gbox
                :h="
                  boxHeight(
                    selectedVenue &&
                      selectedVenue.contact_relations &&
                      selectedVenue.contact_relations.length,
                    NTOffsets.WithDBoxBottom
                  )
                "
                :title="$t('related_contacts')"
              >
                <RelatedContacts
                  :venue="selectedVenue"
                  @changed="onRelatedContactChange"
                  @delete="onContactRelationDelete"
                />
              </gbox>
              <gbox
                :h="
                  boxHeight(
                    selectedVenue &&
                      selectedVenue.private_comments &&
                      selectedVenue.private_comments.length,
                    NTOffsets.WithDBoxBottom
                  )
                "
                :title="$t('private_comments')"
              >
                <DBoxComments
                  :comments="selectedVenue.private_comments"
                  :locationId="`${venue_id}`"
                  :section="'location'"
                  :status="'private'"
                  @delete="onDeleteComment"
                />
              </gbox>
              <gbox
                :h="
                  boxHeight(
                    selectedVenue &&
                      selectedVenue.related_genres &&
                      selectedVenue.related_genres.length,
                    NTOffsets.WithDBoxBottom
                  )
                "
                :title="$t('genres')"
              >
                <DBoxGenres
                  :genres="selectedVenue.related_genres"
                  :id="`${venue_id}`"
                  :section="'location'"
                  :externalTable="'booking_locations'"
                  @delete="onGenreDelete"
                />
              </gbox>
            </gcol>
            <gcol>
              <gbox
                :h="
                  boxHeight(
                    selectedVenue.files && selectedVenue.files.length,
                    NTOffsets.WithDBoxBottom
                  )
                "
                :title="$t('related_documents')"
              >
                <DBoxFiles
                  :files="selectedVenue.files"
                  :externalId="venue_id"
                  :externalTable="'booking_locations'"
                />
              </gbox>
              <gbox
                :h="
                  boxHeight(
                    selectedVenue &&
                      selectedVenue.fields &&
                      selectedVenue.fields.length,
                    2
                  )
                "
                :title="$t('tab_title_custom_fields')"
              >
                <CustomFields
                  v-if="selectedVenue && selectedVenue.fields"
                  :fields="selectedVenue.fields"
                  :section="'bsettings'"
                  :externalTable="'booking_locations'"
                  :module="'settings'"
                  @changed="onVenueCustomFieldChange"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
        <gtab id="bookings" :title="$t('tab_title_bookings')">
          <grow>
            <gcol>
              <gbox
                :h="
                  boxHeight(
                    selectedVenue &&
                      selectedVenue.locations &&
                      selectedVenue.locations.length,
                    NTOffsets.WithHeader
                  ) + 52
                "
                :title="$t('bookings')"
              >
                <VenueBookings
                  :selectedVenue="selectedVenue"
                  @filter="onVenueBookingFilter"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
      </glayout>
    </div>
  </v-container>
</template>

<script>
import { createDTGridHost } from "../../../../dt-plugins/dt-grid/dt-grid.mixin";
import { BookingStoreNamespace as storeNS } from "../../store";
import { mapActions, mapGetters, mapMutations } from "vuex";
import * as ActionTypes from "../../store/types";
import BoxWidget from "@plugins/box-widget/box-widget";
import CustomFields from "@/dt-plugins/custom-fields/custom-fields";

import VenueDetails from "./venue-details";
import VenueInfo from "./venue-info";
import VenueInfo2 from "./venue-info2";
import RelatedContacts from "./related-contacts";
import Communication from "./communication";
import Features from "./features";
import VenueBookings from "./venue-bookings";
import DBoxTextarea from "../../../../dt-plugins/dbox-textarea/dbox-textarea";
import DBoxFiles from "../../../../dt-plugins/dbox-files/dbox-files";
import DBoxComments from "../../../../dt-plugins/comments/dbox-comments";
import DBoxGenres from "../../../../dt-plugins/genres/dbox-genres";
import { checkTabListPermission } from "../../../../router/guard";
import { getDetailsTabRoutes } from "../../../../utility/route";

const moduleRoute = "booking";
const submenuRoute = "venues";

export default {
  components: {
    BoxWidget,
    DBoxTextarea,
    DBoxFiles,
    DBoxComments,
    DBoxGenres,

    VenueDetails,
    VenueInfo,
    VenueInfo2,
    RelatedContacts,
    Communication,
    Features,
    VenueBookings,
    CustomFields
  },
  mixins: [createDTGridHost()],
  data: function() {
    return {
      active: -1
    };
  },
  mounted: function() {},
  watch: {
    // selectedArtistData: {
    //   immediate: true,
    //   handler: function(to, from) {}
    // }
  },
  computed: {
    ...mapGetters(storeNS, {
      // selectedVenue: "selectedVenue",
      // selectedVenueLoading: "selectedVenueLoading",
      venueDetails: "venueDetails"
    }),
    venuSidewindowTabs: function() {
      return checkTabListPermission("booking", "venues", [
        { route: "overview", value: "Overview" },
        {
          route: "additional_info",
          value: "Additional Info"
        },
        {
          route: "bookings",
          value: "Bookings"
        }
      ]);
    },
    venueCustomFieldHint() {
      return `
      ${this.$t(
        "custom-venue-fields-can-be-added-in"
      )} <a href="./#/main/settings/booking/request_settings">${this.$t(
        "menu_Settings"
      )} -> ${this.$t("booking")} -> ${this.$t(
        "tab_title_request_settings"
      )} -> ${this.$t("venue")}</a>
      `;
    },
    venue_id: function() {
      return this.$route.params.venue_id;
    },
    selectedVenue: function() {
      const venueDefault = { location : {}};
      const selectedVenueDetails =  (this.venueDetails || [])[this.venue_id] || venueDefault;
      return {...selectedVenueDetails};
    },
  },
  methods: {
    ...mapActions(storeNS, {
      [ActionTypes.VENUE_LOCATION.UPDATE.SINGLE]:
        ActionTypes.VENUE_LOCATION.UPDATE.SINGLE,
      [ActionTypes.VENUE_RELATED_CONTACTS.UPDATE.SINGLE]:
        ActionTypes.VENUE_RELATED_CONTACTS.UPDATE.SINGLE,
      [ActionTypes.VENUE_RELATED_CONTACTS.DELETE.SINGLE]:
        ActionTypes.VENUE_RELATED_CONTACTS.DELETE.SINGLE,
      [ActionTypes.DELETE_VENUE_LOCATION_COMMENTS]:
        ActionTypes.DELETE_VENUE_LOCATION_COMMENTS,
      [ActionTypes.VENUE_FEATURES.UPDATE.ALL]:
        ActionTypes.VENUE_FEATURES.UPDATE.ALL,
      [ActionTypes.VENUE_FILES.DELETE.SINGLE]:
        ActionTypes.VENUE_FILES.DELETE.SINGLE,
      [ActionTypes.VENUE_GENRES.DELETE.SINGLE]:
        ActionTypes.VENUE_GENRES.DELETE.SINGLE,
      [ActionTypes.VENUE_EVENTS.FETCH.ALL]: ActionTypes.VENUE_EVENTS.FETCH.ALL,
      [ActionTypes.UPDATE_VENUE_CUSTOM_FIELD]:
        ActionTypes.UPDATE_VENUE_CUSTOM_FIELD
    }),

    closeVenueDetails: function(e) {
      this.$emit("closeVenueSidewindow", true);
    },

    onVenueChange: function({ name, value }) {
      // console.log({name, value});
      this[ActionTypes.VENUE_LOCATION.UPDATE.SINGLE]({
        name,
        value,
        item: this.selectedVenue.location
      });
    },
    onRelatedContactChange: function({ name, value, item }) {
      // console.log({ name, value, item });
      this[ActionTypes.VENUE_RELATED_CONTACTS.UPDATE.SINGLE]({
        name,
        value,
        item
      });
    },
    onContactRelationDelete: function(payload) {
      this[ActionTypes.VENUE_RELATED_CONTACTS.DELETE.SINGLE](payload);
    },
    onDeleteComment: function(payload) {
      this[ActionTypes.DELETE_VENUE_LOCATION_COMMENTS](payload);
    },
    onFileDelete: function(file) {
      this[ActionTypes.VENUE_FILES.DELETE.SINGLE](file);
    },
    onFeatureChange: function(features) {
      this[ActionTypes.VENUE_FEATURES.UPDATE.ALL]({
        locationId: this.selectedVenue.location.booking_location_id,
        feature: features
      });
    },
    onMerchandiseInfoBlur: function(event) {
      this.onVenueChange({
        name: "merchandise_info",
        value: event.target.value
      });
    },
    onSponsoringInfoBlur: function(event) {
      this.onVenueChange({
        name: "sponsoring_info",
        value: event.target.value
      });
    },
    onGenreDelete: function(genre) {
      this[ActionTypes.VENUE_GENRES.DELETE.SINGLE](genre);
    },
    onVenueBookingFilter: function(filter) {
      this[ActionTypes.VENUE_EVENTS.FETCH.ALL](filter);
    },
    onVenueCustomFieldChange: function(fields) {
      this[ActionTypes.UPDATE_VENUE_CUSTOM_FIELD](fields);
    }
    // MARK: Methods
  }
};
</script>

<style lang="scss">
.cmp-booking-venue-sidewindow {
  .dt-grid-layout {
    height: calc(100vh - 188px);
  }
  .overview-options {
    margin-top: 7%;
    .icons {
      display: flex;
      justify-content: center;
      img:first-child {
        padding-top: 2px;
      }
      img {
        cursor: pointer;
      }
      .loading-icon-container {
        width: 30px;
        .loading-icon {
          width: 15px;
          height: 15px;
          padding-left: 5px;
        }
      }

      .status {
        margin-top: 17px;
        margin-left: 5px;
        .circle {
          width: 15px;
          height: 15px;
          border-radius: 30px;
        }
      }
    }
  }
}
</style>
